import React from 'react';
import './style.scss';
import { DefaultIcon, FileCurrency } from '../../../atoms/icons';
import { BadgeProps } from '../badge';
import { toUSString } from '../../../atoms/func';

interface Props {
    title: string;
    icon?: React.ReactElement<DefaultIcon> | undefined;
    price: number;
    date: Date;
    id: string | undefined;
    pending?: boolean;
    badgeCard : React.ReactElement<BadgeProps>;
    onViewButton?: React.ReactElement;
    markAsPaidButton?: React.ReactElement;
}

const Pending: React.FC<Props> = (props) => {
  const {
    title, price, date, id, badgeCard,
    pending = true,
    icon = <FileCurrency width={24} />,
    onViewButton,
    markAsPaidButton,
  } = props;
  return (
    <div className="card-pending-container d-flex flex-column justify-content-between" id={id}>
      <div className="d-flex align-items-center">
        <div className="flex-grow-1" style={{ minWidth: 0 }}>
          <div className="d-flex align-items-center">
            <div className={icon ? 'me-2' : 'd-none'}>{icon}</div>
            <div className="card-pending-title">{title}</div>
          </div>
        </div>
        {badgeCard}
      </div>
      <div className="fz-14 mt-2">{`$${price.toLocaleString()}`}</div>
      <div className="d-flex justify-content-between fz-14">
        {pending ? <div>{toUSString(date)}</div>
          : <div>{`Paid (${toUSString(date)})`}</div>}
        {onViewButton}
        {markAsPaidButton}
      </div>
    </div>
  );
};
export default Pending;
